import { render, staticRenderFns } from "./SavedActionButtons.vue?vue&type=template&id=4f06ac04&scoped=true&"
import script from "./SavedActionButtons.vue?vue&type=script&lang=js&"
export * from "./SavedActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./SavedActionButtons.vue?vue&type=style&index=0&id=4f06ac04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06ac04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
